// extracted by mini-css-extract-plugin
export default {"neonWrapper":"Loading_neonWrapper__9jXpj","loading":"Loading_loading__99x3J","l":"Loading_l__F+EvQ"};